module.exports = __webpack_public_path__ + "static/media/man-smiling.52674d47.jpg";